import Stack from '@eversports/klimt-primitives/legacy/Stack'

import { VenueReferAFriendButton } from '../ReferAFriendButton/VenueReferAFriendButton'

import VenueProfileFavoriteButton from './VenueProfileFavoriteButton'
import VenueShareButton from './VenueShareButton'

const FavoriteAndShareButtons = () => {
  return (
    <Stack
      gap={3}
      zIndex={1}
      direction="row"
      alignItems="align-start"
      flexShrink={0}
      sx={{ position: { xs: 'absolute', sm: 'initial' }, top: 12, right: 12 }}
    >
      <VenueProfileFavoriteButton />
      <VenueShareButton />
      <VenueReferAFriendButton />
    </Stack>
  )
}

export default FavoriteAndShareButtons
